import React from "react";
import ViewEyeIcon from "../../../common/Components/Icons/ViewEyeIcon";
import PhotoIcon from "../../../common/Components/Icons/PhotoIcon";
import ProductPreviewImage from "../ProductPreviewImage";
import { useTranslation } from "react-i18next";
import KarigarIcon from "../../../common/Components/Icons/KarigarIcon";
import { formatLatLng } from "../processGeo";

const CommonCard = (props: any) => {
  const {
    media,
    karigar,
    karigarDescription,
    karigarProfileURL,
    name,
    photoProcess,
    karigarBy,
    uploadedBy,
    svg,
    geo,
  } = props;
  const { t } = useTranslation();

  return (
    <div className="rightCard">
      <div className="rightToolTipCard">
        <span className="TriangleIcon">{svg}</span>
        <div className="rightToolTipSubCard">
          <div>{name}</div>
        </div>
      </div>
      <div className="subDiv hkp-journey-karigar">
        <KarigarIcon size={56} url={karigarProfileURL} />
        <div className="hkp-journey-karigar__text">
          <p className="hkp-journey-karigar__name">
            {karigarBy}: <strong>{karigar}</strong>
          </p>
          {karigarDescription ? (
            <p className="hkp-journey-karigar__desc">{karigarDescription}</p>
          ) : null}
        </div>
      </div>
      <div className="subDiv">
        <PhotoIcon />
        <span className="SmallHeading">{photoProcess}</span>
      </div>
      <div className="subDiv1 hkp-journey-media">
        <div className="imagePos">
          <div className="Number">{media?.length || 0}</div>
          {media?.length ? (
            <div
              onClick={() => {
                props.handleOpen({
                  name,
                });
              }}
            >
              <ProductPreviewImage {...props} fileUrl={media[0]} />
            </div>
          ) : (
            <div className="NoUploadImg">{t("No_images_uploaded")}</div>
          )}
        </div>
        <div className="subDiv12">
          <div>
            <div className="dGridM">
              <span className="SmallHeading">{t("Uploaded_by")}: </span>
              <span className="SmallText">{uploadedBy || "—"}</span>
            </div>
            {geo ? (
              <div className="dGridM hkp-journey-geo">
                <span className="SmallHeading">Location: </span>
                <span className="SmallText">{formatLatLng(geo)}</span>
              </div>
            ) : null}
          </div>
          <div className="ViewIcon">
            <ViewEyeIcon
              {...props}
              onClick={() => {
                props.handleOpen({
                  name,
                });
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonCard;
